import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { validationMessages } from '../../../../../i18n/common';
import { LegacyInputTextComponent } from '../../../../../components/prime-formik';
import useSubscriptionExpiredRestrictions from '../../../../../hooks/useSubscriptionExpiredRestrictions';

const EditExecInforContainer = ({ onUpdate, onCancel, executiveReport }) => {
  const { formatMessage } = useIntl();

  const initialValues = { managerTeamName: executiveReport.teamName };
  const validationSchema = Yup.object().shape({
    managerTeamName: Yup.string().required(formatMessage(validationMessages.required)),
  });
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <Formik onSubmit={onUpdate} initialValues={initialValues} validationSchema={validationSchema}>
      {({ isSubmitting }) => (
        <Form>
          <Panel header={`${executiveReport.teamName}`}>
            <div className="p-grid">
              <div className="p-col-12">
                <div className="{{if errors.name 'has-error'}}">
                  <label className="field-label" htmlFor="report-name">
                    <FormattedMessage id="lbl.exec_mng_team_name" defaultMessage="Management Team Name" />
                  </label>
                  <Field
                    id="managerTeamName"
                    placeholder={executiveReport.teamName}
                    type="text"
                    name="managerTeamName"
                    component={LegacyInputTextComponent}
                  />
                </div>
              </div>
              <div className="p-col-12">
                <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
                  {(text) => <Button type="button" label={text} className="p-button-secondary" onClick={onCancel} />}
                </FormattedMessage>
                <FormattedMessage id="actions.save" defaultMessage="Save">
                  {(text) => <Button type="submit" label={text} disabled={isSubmitting || subscriptionIsExpired} />}
                </FormattedMessage>
              </div>
            </div>
          </Panel>
        </Form>
      )}
    </Formik>
  );
};

EditExecInforContainer.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  executiveReport: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default EditExecInforContainer;
